
















import { Component, Prop, Vue } from 'vue-property-decorator';
import RemaxToolbarActions from '@/components/RemaxToolbarActions.vue';

@Component({
    components: {
        RemaxToolbarActions,
    },
})
export default class RemaxToolbar extends Vue {

}

